export const OPS = {
  ENVOI_SALES: { label: "Envoi des sales", short: "Envoi sales", desc: "ANNEZIN → DDO", roles: ["admin", "annezin"], icon: "Truck", accent: "amber" },
  RECEPTION_SALES: { label: "Réception des sales", short: "Réception sales", desc: "Arrivée à DDO", roles: ["admin", "ddo"], icon: "Inbox", accent: "amber" },
  LAVAGE: { label: "Déclaration de lavage", short: "Lavage", desc: "Lavés + rebutés", roles: ["admin", "ddo"], icon: "Droplets", accent: "green", hidden: true },
  LAVAGE_START: { label: "Mise en lavage", short: "Mise en lavage", desc: "Sales → en cours de lavage", roles: ["admin", "ddo"], icon: "Droplets", accent: "amber" },
  LAVAGE_END: { label: "Fin de lavage", short: "Fin de lavage", desc: "En cours → propres / rebuts", roles: ["admin", "ddo"], icon: "Droplets", accent: "green" },
  REPARTITION: { label: "Répartition des propres", short: "Répartition", desc: "Enlèvement chez DDO", roles: ["admin", "annezin"], icon: "Split", accent: "green" },
  RECEPTION_PROPRES: { label: "Réception des propres", short: "Réception propres", desc: "Arrivée sur site", roles: ["admin", "annezin", "ferme_production"], icon: "PackageCheck", accent: "green" },
  ACHAT_NEUFS: { label: "Achat d'emballages neufs", short: "Achat neufs", desc: "Entrée en stock propre", roles: ["admin"], icon: "PackageCheck", accent: "blue", hidden: true },
  PERTE: { label: "Déclaration de perte / casse", short: "Perte / Casse", desc: "Casse ou perte", roles: ["admin", "annezin", "ddo"], icon: "AlertTriangle", accent: "red" },
};

export const OP_MODULE = {
  ENVOI_SALES: "op_envoi_sales",
  RECEPTION_SALES: "op_reception_sales",
  LAVAGE: "op_lavage",
  LAVAGE_START: "op_lavage",
  LAVAGE_END: "op_lavage",
  REPARTITION: "op_repartition",
  RECEPTION_PROPRES: "op_reception_propres",
  PERTE: "op_perte",
  ACHAT_NEUFS: "initial_stock",
};

export const MOTIFS = [
  "Casse manutention chariot",
  "Fissure lavage haute température",
  "Perte sur élevage",
  "Usure / Hors calibre",
  "Autre",
];

export const linesFromMap = (map) =>
  Object.entries(map || {})
    .map(([packaging_type, quantity]) => ({ packaging_type, quantity: Number(quantity) || 0 }))
    .filter((l) => l.quantity > 0);

export const mapFromLines = (lines) => {
  const m = {};
  (lines || []).forEach((l) => {
    m[l.packaging_type] = l.quantity;
  });
  return m;
};
